class SignupEventPopup extends ModalDialog {
  static COOKIE_CLOSED = "signup-event-popup-closed";
  static SESSION_SHOWN = "signup-event-popup-shown";

  constructor() {
    super();
    this.init();
    this.attachExtraListeners();
  }

  init() {
    this.enabled = this.dataset.enabled === "true";
    this.delayMs = (parseFloat(this.dataset.delay) || 3) * 1000;
    this.cooldownDays = parseFloat(this.dataset.cooldownDays) || 1;
    // display_scope = "cart" | "index" | "index,cart" (테마편집 select). 자동 노출을 허용할 template 목록.
    this.allowedTemplates = (this.dataset.displayScope || "cart").split(",");
    this.currentTemplate = this.dataset.currentTemplate || "";
    // 🔴 customer.metafields.custom.welcome_coupon_issued_at (boolean). true 면 발급 완료 → 노출 차단
    this.welcomeCouponIssued = this.dataset.welcomeCouponIssued === "true";
    // URL ?signup_popup=1 강제 트리거 (운영팀 미리보기용). enabled/suppress 룰 모두 무시.
    this.forcePreview = new URLSearchParams(window.location.search).has("signup_popup");
  }

  attachExtraListeners() {
    // 🔴 X 버튼(.signup-event-popup__close)은 cooldown 쿠키 안 심음 — ModalDialog 의 [id^="ModalClose-"] 자동 바인딩으로 hide 만.
    // Maybe Later 만 cooldown 적용. 회귀 주의: 두 버튼 모두 .js-button-close 라 일괄 바인딩 금지.
    const maybeLater = this.querySelector(".signup-event-popup__cta-secondary");
    if (maybeLater) {
      maybeLater.addEventListener("click", this.handleMaybeLater.bind(this));
    }
    // enabled false 면 announcement bar 트리거도 차단. URL 강제 트리거(forcePreview) 시에만 바인딩.
    if (this.enabled || this.forcePreview) {
      this.bindAnnouncementBarTriggers();
    }
  }

  bindAnnouncementBarTriggers() {
    document.querySelectorAll(".announcement-bar").forEach((bar) => {
      if (bar.dataset.signupPopupBound === "1") return;
      bar.dataset.signupPopupBound = "1";
      bar.classList.add("signup-event-popup-trigger");
      bar.setAttribute("role", "button");
      bar.setAttribute("tabindex", "0");
      bar.setAttribute("aria-label", "Open welcome offer");
      bar.addEventListener("click", this.handleAnnouncementClick.bind(this));
      bar.addEventListener("keydown", this.handleAnnouncementKey.bind(this));
    });
  }

  handleAnnouncementClick(e) {
    if (e.target.closest("a, button")) return;
    this.show();
  }

  handleAnnouncementKey(e) {
    if (e.target.closest("a, button")) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.show();
    }
  }

  // 🔴 [중요] this.hide() 누락 시 Maybe Later 클릭이 no-op. ModalDialog 는 [id^="ModalClose-"] 만 hide 자동 바인딩. 회귀 case: wiki/docs/modal-dialog-close-binding-trap.md
  handleMaybeLater() {
    setCookie(SignupEventPopup.COOKIE_CLOSED, "true", this.cooldownDays);
    this.hide();
  }

  connectedCallback() {
    super.connectedCallback();

    // URL ?signup_popup=1 강제 트리거 — enabled/suppress/로그인/페이지 룰 전부 무시하고 즉시 노출 (운영팀 미리보기용)
    if (this.forcePreview) {
      setTimeout(() => this.show(), 100);
      return;
    }

    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") this.show();
      return;
    }

    // enabled false → 자동 노출/트리거 모두 차단 (운영팀이 admin 토글로 ON 할 때까지)
    if (!this.enabled) return;

    // 🔴 [중요] 고객사 요청(2026-08-12): 일반 storefront 에서는 비회원에게만 노출한다.
    // URL 강제 미리보기와 테마 편집기 미리보기는 위에서 먼저 처리하므로 운영 확인은 로그인 상태에서도 가능하다.
    if (this.dataset.customerLoggedIn === "true") return;

    if (!this.allowedTemplates.includes(this.currentTemplate)) return;

    if (this.shouldSuppress()) return;
    this.scheduleShow();
  }

  shouldSuppress() {
    if (this.welcomeCouponIssued) return true;
    if (getCookie(SignupEventPopup.COOKIE_CLOSED) === "true") return true;
    if (sessionStorage.getItem(SignupEventPopup.SESSION_SHOWN)) return true;
    return false;
  }

  scheduleShow() {
    this.timer = setTimeout(() => {
      if (this.shouldSuppress()) return;
      sessionStorage.setItem(SignupEventPopup.SESSION_SHOWN, "1");
      this.show();
    }, this.delayMs);
  }
}

customElements.define("signup-event-popup", SignupEventPopup);
